import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'
import { RadioButton } from 'primereact/radiobutton'
import { Steps } from 'primereact/steps'
import { Divider } from 'primereact/divider'
import { Badge } from 'primereact/badge'
import Loader from '../../Loader/index'
import { notificationDanger } from '../../../utils/customToastify'
import { closeModal } from '../../../common/GlobalModal/redux/GlobalModalActions'

const CombineContacts = ({ selectedRows }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const [companyInfo, setCompanyInfo] = useState(null)
  const [contactInfo, setContactInfo] = useState(null)
  const [additionalInfo, setAdditionalInfo] = useState(null)
  const [addressInfo, setAddressInfo] = useState(null)
  const [redFlagInfo, setRedFlagInfo] = useState(null)
  const [choosenStatuses, setChoosenStatuses] = useState({})
  const [statuses, setStatuses] = useState({})
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    loadStatuses()
  }, [])

  const loadStatuses = async () => {
    const contactsIds = selectedRows.map((row) => ({ id: row.id, name: row.name }))
    const responseStatuses = await axios.get('/contact-divisions/get-statuses-by-contact-ids', {
      params: { contactsIds },
    })
    setStatuses(responseStatuses.data)
  }

  const setStatusInfo = (statusValue) => {
    setChoosenStatuses({ ...choosenStatuses, [statusValue.code]: statusValue })
  }

  const onSaveClick = async () => {
    setIsLoading(true)
    const contactsToDelete = selectedRows.reduce((acc, current) => {
      if (current.id !== companyInfo) {
        acc.push(current.id)
      }
      return acc
    }, [])

    const data = {
      redFlagInfo,
      companyInfo,
      contactInfo,
      additionalInfo,
      addressInfo,
      choosenStatuses,
      contactsToDelete,
    }

    try {
      await axios.post('/contacts/combine-contacts', data)
      setIsLoading(false)
      history.push(`/contacts/${companyInfo}`)
    } catch (e) {
      notificationDanger(e.message)
      setIsLoading(false)
    }
    dispatch(closeModal('combine_contacts'))
  }

  const setBadgeColor = (status) => {
    if (status === 1) {
      return 'danger'
    }
    if (status === 2) {
      return 'warning'
    }
    if (status === 3) {
      return 'success'
    }
    return 'danger'
  }

  let loader
  if (isLoading) {
    loader = <Loader />
  }

  let disableSave = true
  let disableNext = true
  if (companyInfo && contactInfo && additionalInfo && addressInfo && redFlagInfo) disableNext = false
  if (Object.keys(choosenStatuses).length === 11) disableSave = false
  return (
    <>
      {loader}
      <div className='combine-contact combine-contact__stepper'>
        <Steps
          model={[{ label: 'Choose Contact Info' }, { label: 'Choose Status' }]}
          activeIndex={activeIndex}
          onSelect={(e) => setActiveIndex(e.index)}
          readOnly={true}
        />
      </div>
      {activeIndex === 0 && (
        <div className='combine-contact__info-container'>
          <div className='combine-contact__info-container--header'>
            <span className='combine-contact__info-container--header-item'></span>
            <span className='combine-contact__info-container--header-item'>Company Info</span>
            <span className='combine-contact__info-container--header-item'>Contact Info</span>
            <span className='combine-contact__info-container--header-item'>Additional Info</span>
            <span className='combine-contact__info-container--header-item'>Address</span>
            <span className='combine-contact__info-container--header-item'>Red Flag</span>
          </div>
          <Divider />
          {selectedRows.map((row) => (
            <>
              <div className='combine-contact__info-container--body'>
                <span className='combine-contact__info-container--body-item'>
                  <Link
                    className='mb-2'
                    rel='noopener noreferrer'
                    onClick={() => {
                      window.open(`/contacts/${row?.id}`, '_blank')
                    }}
                  >
                    {row?.name}
                  </Link>
                </span>
                <span className='combine-contact__info-container--body-item'>
                  <RadioButton
                    name='companyInfo'
                    value={row.id}
                    onChange={(e) => setCompanyInfo(e.value)}
                    checked={companyInfo === row.id}
                  />
                </span>
                <span className='combine-contact__info-container--body-item'>
                  <RadioButton
                    name='contactInfo'
                    value={row.id}
                    onChange={(e) => setContactInfo(e.value)}
                    checked={contactInfo === row.id}
                  />
                </span>
                <span className='combine-contact__info-container--body-item'>
                  <RadioButton
                    name='additionalInfo'
                    value={row.id}
                    onChange={(e) => setAdditionalInfo(e.value)}
                    checked={additionalInfo === row.id}
                  />
                </span>
                <span className='combine-contact__info-container--body-item'>
                  <RadioButton
                    name='addressInfo'
                    value={row.id}
                    onChange={(e) => setAddressInfo(e.value)}
                    checked={addressInfo === row.id}
                  />
                </span>
                <span className='combine-contact__info-container--body-item'>
                  <RadioButton
                    name='redFlagInfo'
                    value={row.id}
                    onChange={(e) => setRedFlagInfo(e.value)}
                    checked={redFlagInfo === row.id}
                  />
                </span>
              </div>
              <Divider style={{ backgroundColor: '#ceac02', color: '#ceac02' }} />
            </>
          ))}
        </div>
      )}
      {activeIndex === 1 && (
        <>
          <div className='choosen-status'></div>
          <div className='choose-status__container'>
            {Object.keys(statuses).map((contactName) => {
              return (
                <div className='choose-status__box'>
                  <Link
                    className='choose-status__box--header'
                    rel='noopener noreferrer'
                    onClick={() => {
                      window.open(`/contacts/${statuses[contactName][0].contactId}`, '_blank')
                    }}
                  >
                    {contactName.split('_cid_')[0]}
                  </Link>
                  <Divider />
                  {statuses[contactName].map((statusData) => {
                    return (
                      <>
                        <div
                          className={classNames({
                            'choose-status__box--item': true,
                            'choose-status__box--item-disabled':
                              choosenStatuses[statusData.code]?.divisionName &&
                              choosenStatuses[statusData.code]?.contactId !== statusData.contactId,
                          })}
                          onClick={() => setStatusInfo({ ...statusData, contactName })}
                        >
                          <span>{statusData.divisionName}</span>
                          <span>
                            <Badge value={statusData.statusName} severity={setBadgeColor(statusData.statusId)}></Badge>
                          </span>
                          <RadioButton
                            name={statusData.divisionName}
                            value={statusData}
                            onChange={(e) => setStatusInfo({ ...e.value, contactName })}
                            checked={choosenStatuses[statusData.code]?.contactId === statusData.contactId}
                          />
                        </div>
                        <Divider />
                      </>
                    )
                  })}
                </div>
              )
            })}
          </div>
        </>
      )}
      <div className='combine-contact combine-contact__footer'>
        {activeIndex === 0 && (
          <div className='next d-flex flex-column align-items-end'>
            <Button className='btn btn-sm btn-gold next' onClick={() => setActiveIndex(1)} disabled={disableNext}>
              Next
            </Button>
            {disableNext && <small className='text-danger mt-2'>Please select all type of information</small>}
          </div>
        )}
        {activeIndex > 0 && (
          <Button className='btn btn-sm btn-gold' onClick={() => setActiveIndex(0)}>
            Back
          </Button>
        )}
        {activeIndex === 1 && (
          <div className='next d-flex flex-column align-items-end'>
            <Button className='btn btn-sm btn-gold' onClick={onSaveClick} disabled={disableSave}>
              Save
            </Button>
            {disableSave && <small className='text-danger mt-2'>Please select all statuses</small>}
          </div>
        )}
      </div>
    </>
  )
}

export default CombineContacts
